export const ensureSingleItem = (array, defaultItem) => {
  if (!array || array.length === 0) {
    return [defaultItem];
  } else if (array.length > 1) {
    return [array.pop()];
  }
  return array;
};

export const initializeField = (array, field, type) => {
  if (!array[field]?.some((item) => item.type === type)) {
    array[field] = array[field] || [];
    array[field].push({ type });
  }
};
